import type { ShopUser, PublicShopConfig } from '@scayle/storefront-nuxt'
export const isIdpUser = (
  user: MaybeRefOrGetter<ShopUser | undefined>,
  currentShop: PublicShopConfig,
) =>
  ['idp', ...(currentShop.idp?.idpKeys || [])].includes(
    toValue(user)?.authentication?.type ?? '',
  )
